import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router-dom";
import Show from "./Show";
import { useAuthorization } from "../../../common/providers/AuthorizationProvider";
import Edit from "./Edit";
import Create from "./Create";
import "./style.css";

const TeamsMspa = (): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route path="/" element={<Show />} />
      <Route path="/edit/:id" element={<Edit />} />
      <Route path="create" element={<Create />} />
    </Routes>
  );
};

export default TeamsMspa;
